import { Directive, ElementRef, AfterViewInit, Input } from '@angular/core';
import { NgControl, NgForm } from '@angular/forms';

@Directive({
    selector: '[inputSpaceValidate]',
})
export class InputSpaceValidateDirective implements AfterViewInit {
    @Input() isEditMode: boolean;
    private _val: any;
    private _prevVal: any;

    constructor(private el: ElementRef, private ctrl: NgControl, private frm: NgForm) {
    }

    ngAfterViewInit(): void {
        let that = this;

        $(this.el.nativeElement).on('focus', function () {
            that._prevVal = $(this).val();
        });

        $(this.el.nativeElement).on('blur', function () {
            that._val = $(this);
            const val = that._val.val().toString().trim();
            if (that.isEditMode && val === '') {
                if (that._prevVal) {
                    that.ctrl.control.setValue(that._prevVal);
                    that.frm.controls[that.ctrl.name].markAsPristine();
                    that.frm.controls[that.ctrl.name].markAsUntouched();
                    return;
                }
                let trimmedVal = that._val.val().trim();
                that.ctrl.control.setValue(trimmedVal);
                return;
            }
            let trimmedVal = that._val.val().trim();
            that.ctrl.control.setValue(trimmedVal);
            return;
        });
    }
}
